import { fireGtm } from '../util/flyGaLogic'

const clientErrorRedirect = errorMessage => {
  const urlParams = new URLSearchParams(window.location.search)
  const offerToken = urlParams.get('offer-token')
  const passengers = {
    'num-adults': urlParams.get('num-adults') || 1,
    'num-children': urlParams.get('num-children') || 0,
    'num-youths': urlParams.get('num-youths') || 0,
    'num-infants': urlParams.get('num-infants') || 0,
  }

  const passengersParams = new URLSearchParams(passengers).toString()

  const url = `/m/fly/search/noresults?${passengersParams}`

  fireGtm(
    'send',
    'event',
    'MFLY-Listings',
    `Error Redirect: ${url}`,
    errorMessage
  )

  if (offerToken) {
    window.location.assign(`${url}&offer-token=${offerToken}`)
    return
  }
  window.location.assign(url)
}

export { clientErrorRedirect }
